import { initContract } from '@ts-rest/core';
import { publicStatsContract } from './stats.public.contract';

const c = initContract();

export const statsContract = c.router(
  {
    public: publicStatsContract,
  },
  {
    pathPrefix: '/stats',
    strictStatusCodes: true,
  }
);

export * from './stats.public.contract';
